function isLocalStorageValid() {
    try {
        return typeof localStorage?.setItem === 'function';
    } catch (e) {
        return false;
    }
}

export default isLocalStorageValid;
